import type { IInputQuestion } from './_question';
import type { ICheckboxInputProps } from '../Inputs/Checkbox';

import React from 'react';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';

import CheckboxInput from '../Inputs/Checkbox';

import Subtitle from './elements/Subtitle';
import Title from './elements/Title';

import theme from '$/assets/theme';
import getControlError from '$/hooks/getControlError';

export const yupCheckboxInputQuestion = yup.bool().oneOf([true]);

interface ICheckboxInputQuestion
  extends IInputQuestion,
    Omit<ICheckboxInputProps, 'error' | 'name'> {}

const CheckboxInputQuestion = ({
  control,
  name,
  title,
  subTitle,
  ...props
}: ICheckboxInputQuestion) => (
  <Controller
    control={control}
    name={name}
    defaultValue={false}
    render={({ field, fieldState }) => {
      const error = getControlError(control, name, props.errorMessage);

      const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        field.onChange(!!e.target.checked);
      };
      return (
        <>
          {title && <Title>{title}</Title>}
          {subTitle && (
            <Subtitle
              style={{
                color: theme.colors.grey5,
                fontWeight: 'bold',
                textTransform: 'uppercase',
                marginBottom: '-4px',
                fontSize: '13px',
              }}
            >
              {subTitle}
            </Subtitle>
          )}
          <CheckboxInput
            {...field}
            checked={field.value}
            error={fieldState.invalid}
            onChange={onChange}
            containerProps={{
              style: {
                paddingTop: '15px',
              },
            }}
            {...props}
            errorMessage={error.message}
          />
        </>
      );
    }}
  />
);

export default CheckboxInputQuestion;
